import Vue from 'vue'
import App from './App.vue'
import router from './router'
import TweenMax from "gsap/TweenMax"
import TimelineMax from "gsap/TimelineMax"
import fontawesome from '@fortawesome/fontawesome-free/css/all.min.css'
import VueScrollmagic from 'vue-scrollmagic'
// In main.js




Vue.config.productionTip = false

Vue.use(VueScrollmagic, {
  vertical: true,
  globalSceneOptions: {},
  refreshInterval: 100
})



new Vue({
  router,
created(){
  router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()

})

},
  render: h => h(App)
}).$mount('#app')
